<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">GST Slabs</h3>

    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Search GST Slab input -->
      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search slab..."
          class="form-control" style="min-width: 200px;" />
      </div>

      <!-- Create GST Slab button -->
      <button class="btn btnprimary text-nowrap" [routerLink]="['/gst-slab/create']">
        <i class="bi bi-plus-lg"></i> Create GST Slab
      </button>
    </div>
  </div>

  <div class="common-table mt-3">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table align-middle">
        <thead>
          <tr>
            <th>Display Label</th>
            <th>Rate %</th>
            <th>Category</th>
            <th>Description</th>
            <th>Status</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>

        <tbody>
          <!-- Loading -->
          @if (isLoading) {
          <tr>
            <td colspan="6" class="text-center">
              <i class="bi bi-arrow-clockwise spin me-2"></i>Loading...
            </td>
          </tr>
          }

          <!-- Empty -->
          @if (!isLoading && gstSlabs.length === 0) {
          <tr>
            <td colspan="6" class="text-center text-muted">
              No GST slabs found
              @if (searchTerm) {
              <span> for "{{ searchTerm }}"</span>
              }.
            </td>
          </tr>
          }

          <!-- Data rows -->
          @for (slab of gstSlabs; track slab) {
          <tr>
            <td>{{ slab.displayLabel }}</td>
            <td>{{ slab.value }}%</td>
            <td>{{ slab.category || "-" }}</td>
            <td>{{ slab.description || "-" }}</td>
            <td>
              <span class="badge" [class.bg-success]="slab.isActive" [class.bg-secondary]="!slab.isActive">
                {{ slab.isActive ? "Active" : "Inactive" }}
              </span>
            </td>
            <td class="text-center">
              <div class="td-actions-btn">
                <button class="btn btn-sm btn-outline-primary me-1" [routerLink]="['/gst-slab/edit', slab.id]">
                  <i class="bi bi-pencil-square"></i>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>
      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
          <a class="page-link" aria-label="Previous">
            <span aria-hidden="true">&laquo;</span>
          </a>
        </li>

        <!-- First Page -->
        <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
          <a class="page-link">1</a>
        </li>

        <!-- Left Ellipsis -->
        @if (currentPage > 4) {
        <li class="page-item disabled">
          <a class="page-link">...</a>
        </li>
        }

        <!-- Visible Pages -->
        @for (page of getVisiblePages(); track page) {
        <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
          <a class="page-link">{{ page }}</a>
        </li>
        }

        <!-- Right Ellipsis -->
        @if (currentPage < pageCount - 3) { <li class="page-item disabled">
          <a class="page-link">...</a>
          </li>
          }

          <!-- Last Page -->
          @if (pageCount > 1) {
          <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
            <a class="page-link">{{ pageCount }}</a>
          </li>
          }

          <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="goToPage(currentPage + 1)">
            <a class="page-link" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
      </ul>
    </div>
  </div>
</div>